export const environment = {
  baseUrl: 'https://api.scalanthropy.com:8080',
  //baseUrl: 'https://35.208.59.239:8080',
  //baseUrl: 'http://localhost:8080',
  production: false,
}
